module.exports = __webpack_public_path__ + "img/index-logo.2e0c3a08.png";